module.exports = __webpack_public_path__ + "img/google-icon.379dc4ee.svg";